import { cloudChiprApi } from "../../../../../services/cloudchipr.api";

export const getUsersMeOrganisationsCurrentDismissedResourcesSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDismissedResources
    .select;
